/**
 *
 */

(function (window, undefined) {
  'use strict';
  var Route = function ($stateProvider, $urlRouterProvider) {
    var onEnter = [
      'CblMessageSrvc',
      function (messaggiSrvc) {
        messaggiSrvc.reset();
      }
    ];

    $stateProvider
      .state('cdint-proposta-carta-debito-int-pratica-n', {
        url: '/propostaCartaDebitoInternazionale/:idPratica/n/:ndg',
        template: '<cdint-proposta-carta-debito-int class="wrapper"></<cdint-proposta-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Proposta Carta Debito Internazionale',
          parent: 'schedaCliente'
        }
      })
      .state('cdint-proposta-carta-debito-int-prodotto', {
        url: '/propostaCartaDebitoInternazionale/:ndg/:idProdotto/:idTargetMarket',
        template: '<cdint-proposta-carta-debito-int class="wrapper"></<cdint-proposta-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Proposta Carta Debito Internazionale',
          parent: 'schedaCliente'
        }
      })
      .state('cdint-proposta-carta-debito-int-pratica', {
        url: '/propostaCartaDebitoInternazionale/:idPratica',
        template: '<cdint-proposta-carta-debito-int class="wrapper"></<cdint-proposta-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Proposta Carta Debito Internazionale',
          parent: 'schedaCliente'
        }
      })
      // postVendita OBI
      .state('post-vendita-debito-int-pratica', {
        url: '/postVenditaCartaDebitoInternazionale/:ndg',
        template: '<post-vendita-carta-debito-int class="wrapper"></<post-vendita-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Post Vendita Debito Internazionale',
          parent: 'schedaCliente'
        }
      })
      .state('post-vendita-debito-int-pratica-id', {
        url: '/postVenditaCartaDebitoInternazionale/:ndg/:idPratica',
        template: '<post-vendita-carta-debito-int class="wrapper"></<post-vendita-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Post Vendita Debito Internazionale',
          parent: 'schedaCliente'
        }
      })
      .state('req-lott-carta-debito-int', {
        url: '/reqlottCartaDebitoInternazionale',
        template: '<req-lott-carta-debito-int class="wrapper"></<req-lott-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Richiesta Lotto Carte',
          parent: 'home'
        }
      })
      .state('inquiry-lott-carta-debito-int', {
        url: '/inquirylottCartaDebitoInternazionale',
        template: '<inquiry-lott-carta-debito-int class="wrapper"></<inquiry-lott-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Inquiry Richiesta Lotto Carte Instant Issuing',
          parent: 'home'
        }
      });
  };

  Route.$inject = ['$stateProvider', '$urlRouterProvider'];

  angular.module('cbl.cartadebitoint.wa').config(Route);
})(window);



//////////////////
// WEBPACK FOOTER
// ./app/app.route.js
// module id = 2
// module chunks = 0